query TagGroups($first: Int, $after: Cursor, $orderBy: [TagGroupsOrderBy!]) {
  tagGroups(first: $first, after: $after, orderBy: $orderBy) {
    nodes {
      id
      _rowTimestamp
      name
      description
      _isUpdatable
      _isDeletable
      tagGroupItemsByTagGroupId(orderBy: _TAG_BADGE_NAME_ASC) {
        nodes {
          id
          tagId
          _rowTimestamp
          _tagBadgeName
          tag {
            badgeColor
          }
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
  }
}
